import { Injectable } from "@angular/core";
import { ITab } from "./i-tab";
import { ITabTemplate } from "./i-tab-template";
import { TabIdGeneratorService } from "./tab-id-generator.service";
import { TabTemplateInstanceCalculatorService } from "./tab-template-instance-calculator.service";
import { CloudIdStorageService } from '../cloud/cloud-id-storage.service';
import { RegionStorageService } from '../region/region-storage.service';

@Injectable({
  providedIn: "root",
})
export class TabFactoryService {
  constructor(
    private tabIdGeneratorService: TabIdGeneratorService,
    private tabTemplateInstanceCalculator: TabTemplateInstanceCalculatorService,
    private cloudIdStorageService: CloudIdStorageService,
    private regionStorageService: RegionStorageService
  ) {}

  createTab(template: ITabTemplate): ITab {
    return {
      enabled: true,
      closeable: true,
      static: false,
      admin: false,
      storeable: false,
      url: null,
      cloudId: this.loadCloudId(),
      caption: template.name,
      region: this.loadRegion(),
      ...template,
      templateName: template.name,
      id: this.generateNewTabId(),
      instance: this.calculateTabTemplateInstances(template) + 1,
    };
  }

  generateNewTabId(): string {
    return this.tabIdGeneratorService.generateNewTabId();
  }

  calculateTabTemplateInstances(templateName) {
    return this.tabTemplateInstanceCalculator.calculateInstances(templateName);
  }

  loadCloudId() {
    return this.cloudIdStorageService.loadCloudId();
  }

  loadRegion() {
    return this.regionStorageService.loadRegion();
  }
}
